export default {"src":"/_next/static/media/mastercard.e015e93b.svg","height":41,"width":42,"blurWidth":0,"blurHeight":0};